export default {
  default: {
    cvv: {
      title: 'Card Verification Value (CVV):',
      // Setting a width on the cvv-image so that it only takes up part of the help tip content area instead of the full width.
      content: 'The CVV 3-digit security code is located on the back of your card. <br><br><img style="width: 80px; min-height: 51px;" src="/static/cvv-image.png" />'
    },
    whereCanIFindThis: {
      title: 'Policy Number',
      content: 'Your policy number is located at the top of letters and documents you have received from us as well as certain emails. <br><img style="min-height: 114px;" src="/static/policy-id-tooltip-q.png" />'
    }
  },
  sfi: {
    whereCanIFindThis: {
      title: 'Policy Number',
      content: 'Your policy number is located at the top of letters and documents you have received from us as well as certain emails.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/tooltip-content.js